export const filter = {
    id: "",
    name: "",
    search: "",
};
